import React, { useEffect, useState } from "react";
import { Button, Select, Table, Tooltip } from "antd";
import axios from "axios";
import Swal from "sweetalert2";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { EditOutlined, EyeOutlined } from "@ant-design/icons";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import config from "../../../config";
import authHeader from "../../Authentication/authHeader";
import TargetModal from "./TargetModal";

export default function SalesTarget() {
  dayjs.extend(utc);
  dayjs.extend(timezone);
  const TIMEZONE = "Asia/Dhaka";

  const { Option } = Select;
  const { RangePicker } = DatePicker;
  const [centerList, setCenterList] = useState([]);
  const [targetList, setTargetList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [visibility, setVisibility] = useState(false);
  const [userProfile, setUserProfile] = useState(
    JSON.parse(localStorage.getItem("userProfile"))
  );
  const [selectedDateRange, setSelectedDateRange] = useState(null);
  const [selectedCenter, setSelectedCenter] = useState("");
  const [targetLoading, setTargetLoading] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [isView, setIsView] = useState(false);
  const [selectedTargetData, setSelectedTargetData] = useState(null);

  const handleTargetMonthRage = (value) => {
    if (Array.isArray(value) && value.length === 2 && value[0] && value[1]) {
      let startDate = dayjs.tz(value[0], TIMEZONE).startOf("day");
      let endDate = dayjs.tz(value[1], TIMEZONE).endOf("day");
      console.log("startDate: ", startDate);
      console.log("endDate: ", endDate);
      const formattedStartDate = startDate.format(
        "ddd, DD MMM YYYY HH:mm:ss [GMT+6]"
      );
      const formattedEndDate = endDate.format(
        "ddd, DD MMM YYYY HH:mm:ss [GMT+6]"
      );

      setSelectedDateRange([formattedStartDate, formattedEndDate]);
    } else {
      setSelectedDateRange(null);
    }
  };

  const handleCenter = (value) => {
    setCurrentPage(1);
    setSelectedCenter(value);
  };
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleTargetModalVisibility = () => {
    setVisibility(true);
  };

  const handleTargetModalClose = () => {
    setVisibility(false);
    setIsUpdate(false);
    setIsView(false);
    setSelectedTargetData(null);
  };

  const handleUpdateTargetModalVisibility = (record) => {
    setVisibility(true);
    setIsUpdate(true);
    setSelectedTargetData(record);
    setIsView(false);
  };

  const handleViewTargetModalVisibility = (record) => {
    setVisibility(true);
    setIsView(true);
    setSelectedTargetData(record);
    setIsUpdate(false);
  };

  const fetchTargetList = () => {
    setTargetLoading(true);
    axios
      .get(`${config.baseUrl}/inventory/target_list/`, {
        headers: authHeader(),
        params: {
          center_id: selectedCenter,
          dateRange: selectedDateRange,
          page: currentPage,
        },
      })
      .then((response) => {
        setTargetLoading(false);
        setTargetList(response?.data?.results);
        setTotalItems(response?.data?.count);
      })
      .catch((error) => {
        setTargetLoading(false);
        console.log(error);
        Swal.fire({
          title: "Error",
          text: error,
          confirmButtonText: "Ok",
          icon: "error",
        });
      });
  };
  useEffect(() => {
    fetchTargetList();
  }, [currentPage, selectedCenter, selectedDateRange]);

  useEffect(() => {
    setTargetLoading(true);
    axios
      .get(`${config.baseUrl}/inventory/center_list/`, {
        headers: authHeader(),
      })
      .then((response) => {
        setTargetLoading(false);
        setCenterList(response?.data);
      })
      .catch((error) => {
        setTargetLoading(true);
        Swal.fire({
          title: "Error",
          text: error,
          confirmButtonText: "Ok",
          icon: "error",
        });
      });
  }, []);

  const targetColumn = [
    {
      title: "Month",
      dataIndex: "target_month",
      width: "8%",
    },
    {
      title: "Center",
      render: (record) => record?.center?.name,
      width: "8%",
    },
    {
      title: "Product",
      render: (record) => record?.product?.product_name,
      width: "10%",
    },
    {
      title: "Daily",
      width: "5%",
      render: (record) => {
        if (record?.target_details) {
          return record?.target_details?.map((target) => (
            <div key={target.id}>
              {target.target_type === "Daily" ? target?.target_qty : null}
            </div>
          ));
        }
        return null;
      },
    },
    {
      title: "Monthly",
      width: "5%",
      render: (record) => {
        if (record?.target_details) {
          return record?.target_details?.map((target) => (
            <div key={target.id}>
              {target.target_type === "Monthly" ? target?.target_qty : null}
            </div>
          ));
        }
        return null;
      },
    },
    {
      title: "Prepared By",
      render: (record) => record?.prepared_by?.prepared_by_name,
      width: "10%",
    },
    {
      title: "Approved By",
      render: (record) => record?.approved_by?.approved_by_name,
      width: "10%",
    },
    {
      title: "Status",
      render: (record) => record?.status,
      width: "8%",
    },
    {
      title: "Remarks",
      render: (record) => record?.remarks,
      width: "10%",
    },

    {
      title: "Action",
      width: "5%",
      render: (record) => {
        return (
          <React.Fragment>
            <div className="d-flex">
              <Tooltip title="Update">
                <Button
                  disabled={record?.status === "Approved" ? true : false}
                  className="d-flex align-items-center me-1"
                  onClick={() => handleUpdateTargetModalVisibility(record)}
                >
                  <EditOutlined />
                </Button>
              </Tooltip>
              <Tooltip title="View">
                <Button
                  className="d-flex align-items-center"
                  onClick={() => handleViewTargetModalVisibility(record)}
                >
                  <EyeOutlined />
                </Button>
              </Tooltip>
            </div>
          </React.Fragment>
        );
      },
    },
  ];
  return (
    <>
      {visibility && (
        <TargetModal
          visible={visibility}
          modalClose={handleTargetModalClose}
          userProfile={userProfile}
          isUpdate={isUpdate}
          isView={isView}
          data={selectedTargetData}
          fetchTargetList={fetchTargetList}
        />
      )}
      <div className="farmerDashboard">
        <div className="dashboardNameSection">
          <h5 style={{ color: "#46604A" }}>SALES TARGET LIST</h5>
        </div>
        <div className="farmerDashboardContainer shadow-sm rounded">
          <div className="pt-5" style={{ width: "95%", margin: "auto" }}>
            <div className="shadow-sm p-3">
              <div className="m-2 mt-4 d-flex justify-content-between align-items-center">
                <div>
                  <Select
                    placeholder="Select Center"
                    className="me-3"
                    onChange={handleCenter}
                    style={{ width: "200px" }}
                  >
                    <Option value="">All Center</Option>
                    {centerList?.map((center) => (
                      <Option
                        value={center?.center?.employee_id}
                        key={center?.center?.employee_id}
                      >
                        {center?.center_name}
                      </Option>
                    ))}
                  </Select>

                  <RangePicker
                    onChange={handleTargetMonthRage}
                    value={
                      selectedDateRange
                        ? selectedDateRange.map((date) => dayjs(date))
                        : null
                    }
                    style={{ width: "250px" }}
                    picker="month"
                  />
                </div>

                <Button
                  style={{
                    backgroundColor: "#46604A",
                    borderColor: "#46604A",
                    color: "white",
                  }}
                  onClick={handleTargetModalVisibility}
                >
                  Add Target
                </Button>
              </div>
              <Table
                className="border"
                size="small"
                columns={targetColumn}
                dataSource={targetList}
                loading={targetLoading}
                rowKey={(record) => record?.target_id}
                pagination={{
                  current: currentPage,
                  pageSize: 10,
                  total: totalItems,
                  onChange: handlePageChange,
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
